export default __webpack_public_path__ + "static/media/Logout.dc3ee936.png";